module.exports = __webpack_public_path__ + "img/R1Nis5euxRo.7374cb09.jpg";